import { format, isAfter } from "date-fns";

export const FORMAT_YMD_HMS_API = "yyyy-MM-dd HH:mm:ss";
export const FORMAT_YMD_HM = "yyyy-MM-dd HH:mm";
export const FORMAT_YMD_HM_JP = "yyyy'年'MM'月'dd'日' HH:mm";

const FORMAT_YMD = "yyyy-MM-dd";
const FORMAT_YMD_JP = "yyyy'年'MM'月'dd'日'";

export const toDateString = (
  atTimestamp?: number,
  toFormat: string = FORMAT_YMD_HM_JP,
  defaultDateString: string = "--"
) => {
  if (!atTimestamp) return defaultDateString;
  return format(new Date(atTimestamp * 1000), toFormat);
};

const toDate = (timestamp: number): Date => new Date(timestamp);

const toDom = (date: Date): string => format(date, "dd");

const toDomReadable = (timestamp: number): string =>
  format(toDate(timestamp), "dd");

const toMonthReadable = (timestamp: number): string =>
  format(toDate(timestamp), "MM");

const toDateReadable = (timestamp: number): string =>
  format(toDate(timestamp), "yy/MM/dd");

const isSameYMD = (t1: number, t2: number): boolean => {
  let d1 = new Date(t1);
  let d2 = new Date(t2);
  let isSameYear = d1.getFullYear() === d2.getFullYear();
  let isSameMonth = d1.getMonth() === d2.getMonth();
  let isSameDom = d1.getDate() === d2.getDate();
  return isSameYear && isSameMonth && isSameDom;
};

const isAfterBeginCurrentDate = (timestampBeginDate: number) => {
  // item date after current date => hide
  const itemDate = new Date(timestampBeginDate).setHours(0, 0, 0, 0);
  const currentDate = new Date().setHours(0, 0, 0, 0);

  return isAfter(itemDate, currentDate);
};

const toNowApiString = () => {
  let now = Date.now();
  return toDateString(now / 1000, FORMAT_YMD_HMS_API);
};

export {
  toDate,
  toDom,
  toDomReadable,
  toDateReadable,
  isAfterBeginCurrentDate,
  toNowApiString,
  isSameYMD,
  toMonthReadable,
  FORMAT_YMD,
  FORMAT_YMD_JP,
};
